import React, { useState, useRef, useEffect } from "react";
import styles from "../../style/Pages/ClearLogs.module.css";
import { getRegisterId } from "../../utils/authId";
import { TfiClose } from "react-icons/tfi";
import popupsyle from "../../style/PopUp.module.css";
import editpopup from "../../style/Pages/EditPage.module.css";
import RemoveConfirmation from "../../components/ui/Warning/Remove";

const Clearlog = ({ show, close, updated }) => {
  const topRef = useRef(null); // Add this ref

  const register_id = getRegisterId();
  const [timeRange, setTimeRange] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedActions, setSelectedActions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [datas, setDatas] = useState([]);

  useEffect(() => {
    if (errorMessage || (errors?.response_error?.length ?? 0) > 0) {
      topRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [errorMessage, errors]);

  const isCategorySelected = (category) =>
    selectedCategories.includes(category);

  const isActionSelected = (action) => selectedActions.includes(action);

  // const { ClearLogs, isLoading } = useClearLogs();
  const handleTimeRangeChange = (e) => {
    const value = e.target.value;
    setTimeRange(value);

    const currentDate = new Date();
    let from, to;

    switch (value) {
      case "last_day":
        from = new Date(currentDate.setDate(currentDate.getDate() - 1));
        to = new Date();
        break;
      case "today":
        from = new Date();
        to = new Date();
        break;
      case "last_week":
        from = new Date(currentDate.setDate(currentDate.getDate() - 7));
        to = new Date();
        break;
      case "last_month":
        from = new Date(currentDate.setMonth(currentDate.getMonth() - 1));
        to = new Date();
        break;
      case "last_year":
        from = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1));
        to = new Date();
        break;
      case "custom":
        from = "";
        to = "";
        break;
      case "alldata":
        setSelectedCategories(["Group ", "Channel", "Staff Registration"]);
        setSelectedActions(["Add ", "Edit", "Deactive"]);
        return;
      default:
        from = "";
        to = "";
    }

    setFromDate(from ? from.toISOString().split("T")[0] : "");
    setToDate(to ? to.toISOString().split("T")[0] : "");
  };

  const handleErrors = (error) => {
    console.log(error);
    const newErrors = {
      response_error: [],
    };
    if (error.response && error.response.data) {
      const errorData = error.response.data.data;
      for (const key in errorData) {
        if (errorData.hasOwnProperty(key)) {
          newErrors.response_error.push(errorData[key]);
        }
      }
    } else {
      newErrors.response_error.push("An unexpected error occurred.");
    }

    setErrors(newErrors);
  };

  const handleCheckboxChangeCat = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedCategories((prev) => [...prev, value]);
    } else {
      setSelectedCategories((prev) =>
        prev.filter((category) => category !== value)
      );
    }
  };

  const handleCheckboxChangeAct = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedActions((prev) => [...prev, value]);
    } else {
      setSelectedActions((prev) =>
        prev.filter((category) => category !== value)
      );
    }
  };
  const validateForm = () => {
    if (!timeRange) {
      setErrorMessage("Please select a time range.");
      return false;
    }
    if (timeRange !== "alldata" && selectedCategories.length === 0) {
      setErrorMessage("Please select at least one category to delete.");
      return false;
    }
    if (timeRange === "custom" && new Date(fromDate) > new Date(toDate)) {
      setErrorMessage("From date cannot be later than To date.");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const closePopup = () => {
    close();
  };

  const handleDelete = async () => {
    if (!validateForm()) return;
    const payload = {
      user_id: register_id,
    };
    if (timeRange === "all") {
      payload.deleted_data = timeRange;
      payload.category = selectedCategories;
      payload.action = selectedActions;
    } else if (timeRange === "alldata") {
      payload.deleted_data = timeRange;
    } else {
      payload.category = selectedCategories;
      payload.action = selectedActions;
      payload.from_date = fromDate;
      payload.to_date = toDate;
    }
    setDatas(payload);
    setShowAlert(true);
  };

  const handleUpdatedData = () => {
    closePopup();
    updated();
  };
  // if (!show) return null;

  return (
    <div className={popupsyle.popupBackground}>
      <div className={editpopup.editPopupContainer}>
        <div className={popupsyle.PopupContainer}>
          <div className={popupsyle.popupHeader}>
            <h3 className={styles.popupTitle}>Clear System Logs</h3>
            <button className={styles.closeButton} onClick={closePopup}>
              <TfiClose size={18} />
            </button>
          </div>

          <div className={popupsyle.popupContent}>
            <div ref={topRef} /> {/* Scroll target */}
            <div className={styles.formSection}>
              {errorMessage && (
                <div className={styles.errorMessage}>{errorMessage}</div>
              )}

              {errors.response_error && (
                <div className={styles.errorMessage}>
                  {errors.response_error.join(" ")}
                </div>
              )}
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Time Range</label>
                <select
                  className={styles.formSelect}
                  value={timeRange}
                  onChange={handleTimeRangeChange}
                >
                  <option value="">Select time range</option>
                  <option value="alldata">All Data</option>
                  <option value="all">All</option>
                  <option value="today">Today</option>
                  <option value="last_day">Last 2 Days</option>
                  <option value="last_week">Last 7 Days</option>
                  <option value="last_month">Last Month</option>
                  <option value="last_year">Last Year</option>
                  <option value="custom">Custom Date Range</option>
                </select>
              </div>

              {timeRange === "custom" && (
                <div className={styles.dateRangeGroup}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>From Date</label>
                    <input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      className={styles.formInput}
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>To Date</label>
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      className={styles.formInput}
                    />
                  </div>
                </div>
              )}

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Categories to Clear</label>
                <div className={styles.categoryGrid}>
                  {["Group ", "Channel", "Staff Registration"].map(
                    (category) => (
                      <label
                        key={category}
                        className={`${styles.categoryItem} ${
                          isCategorySelected(category)
                            ? styles.categoryItemSelected
                            : ""
                        }`}
                      >
                        <input
                          type="checkbox"
                          value={category}
                          disabled={timeRange === "alldata"}
                          checked={isCategorySelected(category)}
                          onChange={handleCheckboxChangeCat}
                          className={styles.categoryCheckbox}
                        />
                        <span className={styles.categoryName}>
                          {category.charAt(0).toUpperCase() + category.slice(1)}
                        </span>
                      </label>
                    )
                  )}
                </div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Action to Clear</label>
                <div className={styles.categoryGrid}>
                  {["Add ", "Edit", "Deactive"].map((category) => (
                    <label
                      key={category}
                      className={`${styles.categoryItem} ${
                        isActionSelected(category)
                          ? styles.categoryItemSelected
                          : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        value={category}
                        disabled={timeRange === "alldata"}
                        checked={isActionSelected(category)}
                        onChange={handleCheckboxChangeAct}
                        className={styles.categoryCheckbox}
                      />
                      <span className={styles.categoryName}>
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className={popupsyle.popupButtonDiv}>
            <div className={popupsyle.actionButtons}>
              <button className={popupsyle.cancelButton} onClick={closePopup}>
                Cancel
              </button>
              <button className={popupsyle.deleteButton} onClick={handleDelete}>
                Delete Logs
              </button>
            </div>
          </div>
        </div>
      </div>
      {showAlert && (
        <RemoveConfirmation
          onClose={() => setShowAlert(false)}
          datas={datas}
          onSucess={handleUpdatedData}
          errorData={handleErrors}
        />
      )}
    </div>
  );
};

export default Clearlog;
